import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Counter, NegotiationDetails } from '../negotiations.model';
import { NegotiationDetailsService } from 'src/app/services/negotiation-details.service';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CreateNegotiationCounterService } from 'src/app/services/create-negotiation-counter.service';
import { CommonModule, Location } from '@angular/common';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LotsService } from 'src/app/services/lots.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { LoadingSpinnerComponent } from '../../custom/loading-spinner/loading-spinner.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.css'],
  standalone: true,
  imports: [
    LoadingSpinnerComponent,
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
    PriceTypePipe,
  ],
})
export class CounterComponent implements OnInit {
  negotiation: NegotiationDetails;
  isLoading: boolean;
  updateNegotiationInput: FormGroup;

  constructor(
    private negotiationDetailsService: NegotiationDetailsService,
    private createNegotiationCounterService: CreateNegotiationCounterService,
    private snackBar: MatSnackBar,
    private lotsService: LotsService, // used in html template to get Price value from PriceUnion
    private location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (
      this.negotiationDetailsService.getActiveNegotiationDetails() === undefined
    ) {
      this.router.navigate(['../']);
    }
    this.negotiation =
      this.negotiationDetailsService.getActiveNegotiationDetails();
    // console.log('this negotiation counter', this.negotiation);

    this.updateNegotiationInput = new FormGroup({
      lot_id: new FormControl(this.negotiation.lot_id), // string,
      price_value: new FormControl(null, Validators.required),
      volume_value: new FormControl(null, Validators.required),
      ship_begin: new FormControl(null),
      ship_end: new FormControl(null),
      // status: new FormControl(null),
    });
  }

  onSubmit() {
    // console.log("form values",this.updateNegotiationInput.value)
    if (this.updateNegotiationInput.valid) {
      // console.log("form is valid")
      this.createNegotiationCounterService
        .mutate({
          id: this.negotiation._id, //  negotiation id
          input: { ...this.updateNegotiationInput.value },
        })
        .subscribe({
          next: (response) => {
            // console.log(response);
            // this.router.navigate(['/negotiations']); // delete**
            this.snackBar.open(
              `Created counter for ${this.negotiation.commodity} - ${this.negotiation.grade}`,
              'close',
              {
                duration: 3500,
                panelClass: ['blue-snackbar'],
              }
            );
            this.location.back();
            // make material snackbar confirmation
          },
          error: (response) => {
            console.log('error', response);
          },
        });
    }
  }
}
